import React, {Component} from 'react';
import {Timeline, Icon, Alert, Spin, Pagination} from 'antd';
import {timeConverter} from '../utils'

class StationDeviceDatasTimelineChart extends Component {
  state = {
    offset: 0,
    pageSize: 20,
    currentPage: 1
  }

  handlePageChange(page, pageSize) {
    this.setState({
      offset: (page - 1) * pageSize,
      currentPage: page
    })
  }

  render() {
    const {datas, device, fetching} = this.props
    const total = datas
      ? datas.length
      : 0
    const {pageSize, offset, currentPage} = this.state
    let limit = 0
    if (datas && datas.length) {
      limit = offset + pageSize <= datas.length
        ? offset + pageSize
        : datas.length
    }

    const elReceiving = fetching
      ? <span className="center"><Spin/></span>
      : null
    return <div>
      {elReceiving}
      <Timeline>
        {
          datas.slice(offset, limit).map((ev, i) => {
            const color = ev.State === 0
              ? 'green'
              : ev.State === 1
                ? 'orange'
                : 'gray'
            return <Timeline.Item key={i + 1} dot={<Icon type = "clock-circle-o" style = {{ fontSize: 16, color: color }}/>}>
              <span className="time">&nbsp;{ev.Time}
                &nbsp;&nbsp; {`${ev.Text}`}</span>
            </Timeline.Item>
          })
        }
      </Timeline>
      <Pagination current={currentPage} total={total} pageSize={pageSize} onChange={(page, pageSize) => this.handlePageChange(page, pageSize)}/>
    </div>
  }
}

export default StationDeviceDatasTimelineChart;



// WEBPACK FOOTER //
// ./src/components/StationDeviceDatasTimelineChart.js